/* istanbul ignore file */
import React from 'react'
import './reactFlow.css'
import { Tooltip } from '@mui/material'
import ReactFlow from 'reactflow'
import './HierarchyView.css'

const HierarchyView = (props: any): JSX.Element => {
  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 10) {
      return (<Tooltip title={text}><span>{`${text.substring(0, 10)}...`}</span></Tooltip>)
    }
    return <span>{text !== '' ? text : '-'}</span>
  }

  interface EdgeData {
    id: string
    source: string
    target: string
    type?: string
    markerEnd?: {
      type?: string
      width?: number
      height?: number
      color?: string
    }
    style: {
      strokeWidth: number
      stroke: string
      borderRadius?: string
    }
  }

  interface NodeData {
    id?: string
    type: string
    sourcePosition?: string
    targetPosition?: string
    className?: string
    data?: {
      label?: any
    }
    position: { x: number, y: number }
  }

  const nodes: any = [
    {
      id: props?.site?.id,
      type: 'input',
      sourcePosition: 'bottom',
      data: {
        label: (
            <>
              <div style={{ textAlign: 'center', fontWeight: 'normal', marginBottom: '5px', color: 'grey' }}>Site</div>
              {formatTextWithTooltip(props?.site?.name)}
            </>
        )
      },
      position: { x: 0, y: 0 }
    }
  ]
  const edges: any = []
  let gatewayCount = 0
  let deviceCount = 0

  props?.site?.assetList?.map((res: any, index: any) => {
    const nodeData: NodeData = {
      id: res?.id,
      type: 'default',
      targetPosition: 'left',
      sourcePosition: 'bottom',
      data: {
        label: (
            <>
              <div style={{ textAlign: 'center', fontWeight: 'normal', marginBottom: '5px', color: 'grey' }}>Asset</div>
              {formatTextWithTooltip(res?.name)}
            </>
        )
      },
      position: { x: 200, y: ((parseInt(index) + 1) * 100) }
    }
    nodes?.push(nodeData)

    const edgesData: EdgeData = {
      id: `${parseInt(props?.site?.id)}-${parseInt(res?.id)}`,
      source: props?.site?.id,
      target: res?.id,
      type: 'step',
      markerEnd: {
        type: 'arrow',
        width: 20,
        height: 20,
        color: '#818181'
      },
      style: {
        strokeWidth: 1,
        stroke: '#818181'
      }
    }
    edges?.push(edgesData)

    res?.gateway?.map((res2: any) => {
      const nodeData2: NodeData = {
        id: res2?.id,
        type: 'default',
        targetPosition: 'left',
        sourcePosition: 'bottom',
        className: 'gateway-selected',
        data: {
          label: (
              <>
                <div style={{ textAlign: 'center', fontWeight: 'normal', marginBottom: '5px', color: 'grey' }}>Gateway</div>
                {formatTextWithTooltip(res2?.name)}
              </>
          )
        },
        position: { x: 400, y: ((gatewayCount + 1) * 100 + 100) }
      }
      nodes?.push(nodeData2)

      const edgesData2: EdgeData = {
        id: `${parseInt(res?.id)}-${parseInt(res2?.id)}`,
        source: res?.id,
        target: res2?.id,
        type: 'step',
        markerEnd: {
          type: 'arrow',
          width: 20,
          height: 20,
          color: '#818181'
        },
        style: {
          strokeWidth: 1,
          stroke: '#818181'
        }
      }
      edges?.push(edgesData2)
      gatewayCount++

      res2?.device?.map((res3: any) => {
        const nodeData3: NodeData = {
          id: res3?.id,
          type: 'output',
          targetPosition: 'left',
          sourcePosition: 'bottom',
          data: {
            label: (
                <>
                  <div style={{ textAlign: 'center', fontWeight: 'normal', marginBottom: '5px', color: 'grey' }}>Device</div>
                  {formatTextWithTooltip(res3?.name)}
                </>
            )
          },
          position: { x: 600, y: ((deviceCount + 1) * 100 + 200) }
        }
        nodes?.push(nodeData3)

        const edgesData3: EdgeData = {
          id: `${parseInt(res2?.id)}-${parseInt(res3?.id)}`,
          source: res2?.id,
          target: res3?.id,
          type: 'step',
          markerEnd: {
            type: 'arrow',
            width: 20,
            height: 20,
            color: '#818181'
          },
          style: {
            strokeWidth: 1,
            stroke: '#818181'
          }
        }
        edges?.push(edgesData3)

        deviceCount++
        return res3
      })
      return res2
    })
    return res
  })

  return (
      <div className={`hierarchy-gateway-container ${(nodes.length > 7 ? 'gateway-extra-nodes' : '')}`}>
        <ReactFlow
            nodes={nodes}
            edges={edges}
            fitView
            fitViewOptions={{
              padding: 2
            }}
            nodesDraggable={false}
            zoomOnDoubleClick={true}
            // paneMoveable={false}
            snapToGrid={true}
            snapGrid={[15, 15]}
            style={{ width: '100%', height: '100%' }}
        />
      </div>
  )
}

export default HierarchyView
